'use strict';

exports.__esModule = true;
exports['default'] = isPristine;

function isPristine(initial, data) {
  if (initial === data) {
    return true;
  }
  if (initial && typeof initial === 'object') {
    if (!data || typeof data !== 'object') {
      return false;
    }
    var dataKeys = Object.keys(data);
    for (var index = 0; index < dataKeys.length; index++) {
      var key = dataKeys[index];
      if (!isPristine(initial[key], data[key])) {
        return false;
      }
    }
  } else if (initial || data) {
    // allow '' to equate to undefined or null
    return initial === data;
  }
  return true;
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/isPristine.js
// module id = 2141
// module chunks = 0